import { render } from "./assistance-count.vue?vue&type=template&id=c57713d2&scoped=true"
import script from "./assistance-count.vue?vue&type=script&lang=js"
export * from "./assistance-count.vue?vue&type=script&lang=js"

import "./assistance-count.vue?vue&type=style&index=0&id=c57713d2&scoped=scoped&lang=less"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c57713d2"]])

export default __exports__